import React from "react";
import { Typography } from "@plum-xoxo/admin-dsm";

const DiwaliGifting = ({ currency = "INR", typeformParams = "" }) => {
  return (
    <a
      href={`https://survey.typeform.com/to/edPxSmF1${typeformParams}`}
      target="_blank"
      rel="noreferrer"
      className="mr-28"
    >
      <Typography.LabelText
        id={`bulk-gifting-title`}
        className="cursor-pointer"
        color="dark"
        shade="c200"
        component="div"
      >
        Diwali Gifting <img src="/admin/img/svg-icons/Sparkle.svg" />
      </Typography.LabelText>
    </a>
  );
};

export default DiwaliGifting;
